// // // src/authConfig.js
import { PublicClientApplication, LogLevel } from "@azure/msal-browser";
import { envConfig } from "./config/envConfig";
export const authConfigData = {
    auth: {
        clientId: envConfig.auth.clientId,
        authority: envConfig.auth.authority,
        redirectUri: envConfig.auth.redirectUri,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },

    system: {
        loggerOptions: {
            logLevel: LogLevel.Verbose,
            loggerCallback: (level, message, containsPii) => {
                if (!containsPii) {
                    return
                };
            }
        }
    }

};

export const loginRequest = {
    //scopes: ["openid", "profile", "User.Read", "email"],
    //scopes: ["api://463fc679-2d86-4913-b141-408b34ced827/access_as_user"], //DEV
    scopes: ["api://ed0ad555-6b7c-435a-8b85-1de51f3b99ce/access_as_user"], //UAT
    prompt: "select_account"
};

// PRODUCTION
// export const loginRequest = {
//     scopes: ["api://9d6ac033-5951-4f32-b244-805b0535804b/access_as_user"], //PROD
//     prompt: "select_account"
// };

const msalInstance = new PublicClientApplication(authConfigData);
export async function getMsalInstance() {
    await msalInstance.initialize();
    await msalInstance.handleRedirectPromise();
    return msalInstance;
}
export { msalInstance };